export const getSurveys = (state) => {
  let surveys = state.surveys.slice()

  if (state.sortBy === 'date') {
    surveys.sort(function (a, b) {
      if (!a.fields) return -1
      if (!b.fields) return 1
      if (a.fields.frm_date_start === b.fields.frm_date_start) {
        const altA = a.fields.frm_date_created
        const altB = b.fields.frm_date_created
        return altA > altB ? -1 : altA < altB ? 1 : 0
      }
      const aStart = new Date(a.fields.frm_date_start)
      const bStart = new Date(b.fields.frm_date_start)
      return aStart > bStart ? -1 : aStart < bStart ? 1 : 0
    })
  } else {
    surveys.sort(function (a, b) {
      return a.frm_label < b.frm_label ? -1 : 1
    })
  }

  return surveys
}

export const getQuestionItems = (state) => {
  return state.questionItems
}

export const getActiveSurvey = (state) => {
  return state.activeSurvey
}

export const getActiveSurveyUserCount = (state) => {
  return state.activeSurveyUserCount
}

export const getActiveSurveyTotalUsers = (state) => {
  let users = state.activeSurveyUserCount.status
  let total = 0

  for (const status in users) {
    if (users.hasOwnProperty(status)) {
      total += users[status];
    }
  }
  return total
}

export const getTemplate = (state) => {
  return state.templateObject
}

export const getActiveSurveyDate = (state) => {
  return state.surveyData
}

export const getDateEnd = (state) => {
  return state.activeSurvey.fields.frm_date_end
}
